<template>
	<div class="add-product" style="background-color: white; padding: 10px 15px;">
		<el-form
			:label-position="labelPosition"
			:rules="rules"
			ref="apps"
			label-width="80px"
			:model="apps"
		>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item
						:label="$t('myApps.icon')"
						prop="icon"
						style="margin-bottom: 5px;"
					>
						<el-upload
							class="upload-demo"
							:action="uploadUrl"
							:headers="headers"
							accept=".jpg,.png"
							:on-success="
								(response, file, fileList) =>
									handleSuccess(response, file, fileList, 1)
							"
							:before-upload="file => beforeUpload(file, 1)"
							:on-remove="(file, fileList) => handleRemove(file, fileList, 1)"
							:on-error="
								(err, file, fileList) => handleError(err, file, fileList, 1)
							"
							:file-list="iconlist"
							:limit="limit"
							list-type="picture-card"
						>
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item
						:label="$t('myApps.title')"
						prop="title"
						style="margin-bottom: 5px;"
					>
						<el-input
							v-model="apps.logoUrl"
							:placeholder="$t('myApps.ptitle')"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item
						:label="$t('myApps.desc')"
						prop="desc"
						style="margin-bottom: 5px;"
					>
						<el-input
							type="textarea"
							v-model="apps.desc"
							:placeholder="$t('myApps.pdesc')"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item :label="$t('myApps.content')" prop="content">
						<el-tiptap
							v-model="apps.content"
							:extensions="extensions"
							:lang="
								this.$i18n.locale == 'zh_CN'
									? 'zh'
									: this.$i18n.locale == 'en_US'
									? 'en'
									: 'en'
							"
						/>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-button
			type="primary"
			:disabled="loadingForm"
			@click="submitForm"
			style="margin-top: 30px;"
			>{{ $t("promote.save") }}</el-button
		>
	</div>
</template>

<script>
import config from "@/http/config";
import {
	// 需要的 extensions
	Doc,
	Text,
	Paragraph,
	Heading,
	Bold,
	Underline,
	Italic,
	Strike,
	ListItem,
	BulletList,
	OrderedList,
	Link,
	Image,
	CodeBlock,
	Blockquote,
	TodoItem,
	TodoList,
	TextAlign,
	FontSize,
	FontType,
	Fullscreen,
	TextHighlight,
	TextColor,
	FormatClear,
	Table,
	TableHeader,
	TableCell,
	TableRow,
	History,
	TrailingNode,
	HardBreak,
	HorizontalRule,
	LineHeight,
	Indent,
} from "element-tiptap";
export default {
	name: "PromoteConfig",
	data() {
		return {
			labelPosition: "top",
			limit: 1,
			uploadUrl: config.baseUrl + this.$url.Upload.apps,
			headers: {
				token: this.$cookies.get("token"),
			},
			loadingForm: false,
			apps: {},
			logolist: [],
			iconlist: [],
			homeSignImglist: [],
			homeBackImglist: [],
			extensions: [
				new Doc(), // 必须项
				new Text(), // 必须项
				new Paragraph(), // 必须项
				new Heading({ level: 6 }), // 标题
				new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
				new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
				new Italic({ bubble: true }), // 斜体
				new Strike({ bubble: true }), // 删除线
				new ListItem(), // 使用列表必须项
				new BulletList({ bubble: true }), // 无序列表
				new OrderedList({ bubble: true }), // 有序列表
				new Link(), // 链接
				new Image(), // 图片
				new CodeBlock({ bubble: true }), // 代码块
				new Blockquote(), // 引用
				new TodoItem(), // 任务列表必须项
				new TodoList(), // 任务列表
				new TextAlign({ bubble: true }), // 文本对齐方式
				new FontSize({ bubble: true }), // 字号
				new FontType({ bubble: true }), // 字体
				new Fullscreen(), // 全屏
				new TextHighlight({ bubble: true }), // 文本高亮
				new TextColor({ bubble: true }), // 文本颜色
				new FormatClear({ bubble: true }), // 清除格式
				new Table({ resizable: true }), // 表格
				new TableHeader(), // 表格必须项
				new TableCell(), // 表格必须项
				new TableRow(), // 表格必须项
				new History(), // 撤销
				new TrailingNode(), // 重做
				new HardBreak(), // 分割线
				new HorizontalRule(), // 行距
				new LineHeight(), // 增加缩进
				new Indent(), // 减少缩进
			],
		};
	},
	mounted() {
		let url = this.$url.Promote.get;
		let method = this.$method.get;
		this.$api
			.request(url, method, {
				key: "LOGO",
			})
			.then(res => {
				if (res.code === 0) {
					this.apps = res.data;
					if (res.data.logo && res.data.logo != "") {
						if (this.logolist.length <= 0) {
							this.logolist.push({ url: res.data.logo });
						}
						this.hideUpload(0);
					}
					if (res.data.icon && res.data.icon != "") {
						if (this.iconlist.length <= 0) {
							this.iconlist.push({ url: res.data.icon });
						}
						this.hideUpload(1);
					}
					if (res.data.homeSignImg && res.data.homeSignImg != "") {
						if (this.homeSignImglist.length <= 0) {
							this.homeSignImglist.push({ url: res.data.homeSignImg });
						}
						this.hideUpload(2);
					}
					if (res.data.homeBackImg && res.data.homeBackImg != "") {
						if (this.homeBackImglist.length <= 0) {
							this.homeBackImglist.push({ url: res.data.homeBackImg });
						}
						this.hideUpload(3);
					}
				}
			})
			.catch(err => {
				this.$notify({
					title: this.$t("common.tip"),
					message: err.msg,
					type: "error",
				});
			});
	},
	methods: {
		submitForm() {
			this.loadingForm = true;
			let url = this.$url.Promote.save;
			let method = this.$method.post;
			this.$api
				.request(url, method, {
					type: "LOGO",
					content: JSON.stringify(this.apps),
				})
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
					} else {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "error",
						});
					}
					this.loadingForm = false;
				})
				.catch(err => {
					this.$notify({
						title: this.$t("common.tip"),
						message: err.msg,
						type: "error",
					});
					this.loadingForm = false;
				});
		},
		// 文件上传成功钩子
		handleSuccess(response, file, fileList, i) {
			let field = "";
			if (i == 0) {
				field = "logo";
			} else if (i == 1) {
				field = "icon";
			} else if (i == 2) {
				field = "homeSignImg";
			} else if (i == 3) {
				field = "homeBackImg";
			}
			if (response.code === 0) {
				this.apps[field] = response.data;
			}
			this.hideUpload(i);
			console.log(this.apps);
		},
		beforeUpload(file, i) {
			console.log(file);
			this.hideUpload(i);
		},
		handleRemove(file, fileList, i) {
			this.showUpload("", i);
		},
		hideUpload(i) {
			this.$nextTick(() => {
				let card = window.document.querySelectorAll(".el-upload--picture-card");
				card[i].style.display = "none";
			});
		},
		showUpload(boo, i) {
			if (boo) {
				this.$nextTick(() => {
					let card = window.document.querySelectorAll(
						".el-upload--picture-card"
					);
					card[i].style.display = "block";
				});
			} else {
				setTimeout(() => {
					let card = window.document.querySelectorAll(
						".el-upload--picture-card"
					);
					card[i].style.display = "block";
				}, 1000);
			}
		},
		handleError(err, file, fileList, i) {
			this.$message.error(err.msg ? err.msg : this.$t("addProduct.error"));
			this.showUpload("", i);
		},
	},
};
</script>

<style lang="scss">
.editor {
	height: 300px;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
.add-product {
	.el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 88px;
	}
	.el-upload-list__item {
		width: 80px !important;
		height: 80px !important;
		margin-bottom: 0 !important;
	}
	.el-form-item__content {
		line-height: 0;
	}
}
</style>
